<h3 mat-dialog-title>Stop Using Account as a Deposit Destination?</h3>
<img (click)="closeDialog()" class="mat-close" src="/assets/images/payhoa/other/icon_close.svg">

<mat-dialog-content>
    <p>{{data.account.friendlyName}} is a deposit account.</p>
    <p>
        It is capable of being a deposit destination for funds your users pay for charges.
        You must select a different deposit account to replace this account
        for funds from any such items.
    </p>

    <hr class="mb-3"/>

    <label>
        New Bank Account:
    </label>

    <select [(ngModel)]="replacementDepositAccount"
            class="form-control  form-control-sm">
        <!--suppress HtmlUnknownAttribute -->
        <ng-template [ngForOf]="data.replacementCandidates"
                     let-bank
                     ngFor>
            <option [innerHTML]="bank.friendlyName"
                    [ngValue]="bank"></option>
        </ng-template>
    </select>
</mat-dialog-content>

<mat-dialog-actions>
    <button (click)="closeDialog()" class="btn btn-outline-secondary">
        Cancel
    </button>
    <button (click)="replaceDepositAccount()" [disabled]="!replacementDepositAccount || isReplacementRequestInFlight"
            class="btn btn-primary">
        Remove and Replace
    </button>
</mat-dialog-actions>
